import { z } from 'zod';
import { getAvailableFusionDashboards } from '@/services/dashboards/fusion-dashboards-service';
import {
	getDashboardsSchema,
	GetDashboardsContext,
	DashboardsResult,
} from './types';
import { TOOL_NAME_GET_DASHBOARDS, toEngineName } from '@/constants';
import { devDebug } from '@/utils/dev-debug';

/**
 * Standalone dashboards engine - completely decoupled from any UI or store
 * @param params - The parameters for getting dashboards (currently empty)
 * @param context - Context with tool call ID for tracking
 * @returns The dashboards result with list of dashboards
 */
export async function getDashboardsEngine(
	params: z.infer<typeof getDashboardsSchema>,
	context: GetDashboardsContext,
): Promise<DashboardsResult> {
	devDebug('engineCall', {
		engine: toEngineName(TOOL_NAME_GET_DASHBOARDS),
		toolCallId: context.toolCallId,
	});

	const dashboards = await getAvailableFusionDashboards(context.httpClient);

	return {
		dashboards,
	};
}
